<div style="display: flex; flex-direction: column; margin: 20px auto; z-index: 1; overflow: hidden; width: 66%">
  <div class="container">
    <mat-toolbar color="primary" class="toolbar-over-card" style="padding: 20px;">
      <div>Edit Upload</div>
    </mat-toolbar>
    <mat-card appearance="outlined" class="scrollable-content">
      <mat-card-content *ngIf="currentUpload" [formGroup]="uploadFormGroup">
        <div style="display: flex;">
          <div style="flex-grow: 1">
            <div class="form-control-wrapper">
              <mat-form-field appearance="fill" style="width: 100%">
                <mat-label>Title</mat-label>
                <textarea matInput placeholder="Note title" cdkTextareaAutosize
                          formControlName="title"></textarea>
              </mat-form-field>
            </div>
            <div class="form-control-wrapper">
              <mat-form-field appearance="fill" style="width: 100%">
                <mat-label>Comments</mat-label>
                <textarea matInput placeholder="Note content" cdkTextareaAutosize
                          formControlName="comments" style="min-height: 100px;"></textarea>
              </mat-form-field>
            </div>
          </div>
          <div style="flex-grow: 1; padding-left: 20px; display: flex; flex-direction: column; gap: 10px;">
            <div><strong>Username:</strong> {{currentUpload.username}}</div>
            <div><strong>Custodian:</strong> {{currentUpload.custodianName}}</div>
            <div><strong>Doc Source:</strong> {{currentUpload.docSource}}</div>
            <div><strong>Utc Offset:</strong> {{currentUpload.utcOffset}}</div>
            <div><strong>Date:</strong> {{currentUpload.uploadDate| date: 'medium'}}</div>
          </div>
        </div>
      </mat-card-content>
      <mat-card-actions align="end" *ngIf="currentUpload">
        <button mat-button color="primary" [disabled]="isSaveDisabled()" (click)="save()">Save</button>
        <button mat-button color="primary" (click)="cancel()">Cancel</button>
      </mat-card-actions>
    </mat-card>
  </div>

</div>
